export default __webpack_public_path__ + "static/freelancer-nl-29e3046b829f80f57363d1f869e81801b4620fb05cf88b3ee478675821931c6c.svg";